import { render, staticRenderFns } from "./BundlePaymentDistribution.vue?vue&type=template&id=cfefeb32&scoped=true"
import script from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
export * from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
import style0 from "./BundlePaymentDistribution.vue?vue&type=style&index=0&id=cfefeb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfefeb32",
  null
  
)

export default component.exports